import { Profile } from '@/components/home/Profile';
import { ActiveTask } from '@/components/home/ActiveTask';
import { ActiveVehicle } from '@/components/home/ActiveVehicle';
import { useDriveOnContext } from '@/contexts/DriveOnContext';
import { getLatestDriveOnDriverInput } from '@/generated/client/driveon-api/driveon-api';
import { useEffect } from 'react';
import { DriveOnStatusDto } from '@/generated/model';
import { Logbook } from '@/model/Logbook';
import { DriveOnDriverInputInputType as InputType } from '@/generated/model/driveOnDriverInputInputType';
import { useTranslation } from 'react-i18next';
import { useNotificationContext } from '@/contexts/NotificationCtx';
export function Home() {
  const { t } = useTranslation();
  const driveOnCtx = useDriveOnContext();
  const notifyCtx = useNotificationContext();

  useEffect(() => {
    const contextIsLoaded = driveOnCtx.inputType || driveOnCtx.logbook || driveOnCtx.target || driveOnCtx.task;
    async function refreshTarget() { //only target can change without user interaction
      if (contextIsLoaded) {
        const result = await getLatestDriveOnDriverInput();

        if (result && result.status == 200) {
          const data = result.data;
          const driverInput = data.driverInput;
          const inputType = driverInput?.inputType;
          const target = driverInput?.target;
    
          if (inputType === InputType.TARGET_UNASSIGNED) {
            const msg: string = 'Ön kijelentkezett a ' + target?.name + ' járműből!';
            if (driveOnCtx?.inputType !== inputType) {
              notifyCtx?.showNotification('info', msg, undefined, 10);
              clearContext();
            }
          } else if (inputType === InputType.MIDNIGHT_CLEANUP) {
            const msg: string = 'Éjféli kijelentkezés miatt kiléptettük a ' + target?.name + ' járművéből';
            if (driveOnCtx?.inputType !== inputType) {
              notifyCtx?.showNotification('info', msg, undefined, 10);
              clearContext();
            }
          } else if (inputType === InputType.KICKED) {
            if (driveOnCtx?.inputType !== inputType) {
              notifyCtx?.showNotification('error', t('home.activevehicle.kicked'), undefined, 10);
              clearContext();
            }
          } else {
            if (!driveOnCtx?.target) {
              driveOnCtx.setTarget(target);
            }
          }
          driveOnCtx.setInputType(inputType);
          console.log('refreshTarget(): Api called: getLatestDriveOnDriverInput');
        }
      }
    }

  function clearContext() {
    driveOnCtx.setTarget(undefined);
    driveOnCtx.setLogbook(undefined);
    driveOnCtx.setTask(undefined);
  }

    refreshTarget();
  }, []);

  useEffect(() => {
    const contextIsNotLoaded = !driveOnCtx.inputType && !driveOnCtx.logbook && !driveOnCtx.target && !driveOnCtx.task;
    async function reloadPageContent() {
      if (contextIsNotLoaded) {
        const result = await getLatestDriveOnDriverInput().catch((error) => {
          const data = error.response.data;
          if (data.exceptionClass.includes('UserNotInDriverInputException')) {
            // const msg: string = 'Üdvözöljük!. Első bejelentkezés!';
            // notifyCtx?.showNotification('info', msg, undefined, 10);
          }
        });

        if (result && result.status == 200) {
          const data = result.data;
          updateDriveOnContext(data);
          console.log('reloadPageContent(): Api called: getLatestDriveOnDriverInput');
        }
      }
    }

    function updateDriveOnContext(data: DriveOnStatusDto) {
      const inputType = data.driverInput?.inputType;
      const target = data.driverInput?.target;
      driveOnCtx.setInputType(inputType);

      if (inputType === InputType.TARGET_UNASSIGNED) {
        const msg: string = 'Ön kijelentkezett a ' + target?.name + ' járműből!';
        notifyCtx?.showNotification('info', msg, undefined, 10);
        eraseContext();
      } else if (inputType === InputType.MIDNIGHT_CLEANUP) {
        const msg: string = 'Éjféli kijelentkezés miatt kiléptettük a ' + target?.name + ' járművéből';
        notifyCtx?.showNotification('info', msg, undefined, 10);
        eraseContext();
      } else if (inputType === InputType.KICKED) {
        notifyCtx?.showNotification('error', t('home.activevehicle.kicked'), undefined, 10);
        eraseContext();
      } else {
        updateContext(data)
      }
    }

    function eraseContext() {
      driveOnCtx.setTarget(undefined);
      driveOnCtx.setTask(undefined);
      driveOnCtx.setLogbook(undefined);
    }

    function updateContext(data: DriveOnStatusDto) {
      const driverInput = data.driverInput;
      const task = data.task;
      const target = data?.driverInput?.target;
      driveOnCtx.setTarget(target);
      driveOnCtx.setTask(task);
      driveOnCtx.setLogbook({
        taskName: driverInput?.task?.name,
        destination: driverInput?.destination,
        productDescription: driverInput?.productDescription,
        productWeight: driverInput?.productWeight,
        personCount: driverInput?.personCount,
        trailer: driverInput?.trailer,
        workingHours: driverInput?.target.egs ? 0 : driverInput?.workingHours,
        heatingHours: driverInput?.target.egs ? 0 : driverInput?.heatingHours,
        comment: driverInput?.comment,
      } satisfies Logbook);
    }
  
    reloadPageContent();
  }, []);

  function isEGSTarget(): boolean {
    if (driveOnCtx.target && driveOnCtx.target.egs) {
      return true;
    }
    return false;
  }

  return (
    <>
      <Profile />
      {!isEGSTarget() && <ActiveTask/>}
      <ActiveVehicle />
    </>
  );
}
